const USER_STATUSES = {
  active: 'Active',
  invited: 'Invited'
} as const;

const USER_TYPES = {
  user: 'User',
  api_user: 'ApiUser',
  anonymous: 'Anonymous'
} as const;

export { USER_STATUSES, USER_TYPES };
